import axios from 'axios';
import WriteLog from '../Globals/WriteLog';



//Cust Document
export async function PreviewCustLocDoc(e, doc_seq, setReportLoading, token, docType, docName){    
    e.preventDefault();
    console.log("PreviewCustLocDoc->doc_seq", doc_seq);
    console.log("PreviewCustLocDoc->token", token );
    console.log("PreviewCustLocDoc->docType", docType );
    //"work_order/documents/{doc_name}";
    const endPoint = process.env.REACT_APP_SERVER_BASE_URL +'/work_order/documents/'+doc_seq
    console.log("PreviewCustLocDoc->endPoint", endPoint );
    setReportLoading(true)
    await axios.get(endPoint,    
        {                
            headers: {                
                'Authorization':token,                    
            },
        }
        ).then(function (res){
            setReportLoading(false)       

                var contentType = ""
                if(docType === "pdf" || docType === "doc" || docType === "docx" || docType === "xls" || docType === "xlsx")
                    contentType = "application/"+docType;

                else if(docType === "jpg" || docType === "jpeg" || docType === "png" || docType === "bmp" || docType === "ico")
                    contentType = "image/"+docType;
                
                else if(docType === "text" || docType === "csv")
                    contentType = "text/"+docType;

                var file = new Blob([base64ToArrayBuffer(res.data)], { type: contentType });
                WriteLog("PreviewCustLocDoc->file", file)                
                var fileURL = URL.createObjectURL(file);                    
                WriteLog("PreviewCustLocDoc->fileURL", fileURL)
                window.open(fileURL);
                URL.revokeObjectURL(fileURL)                                  
               
            }).catch(function(error){
                setReportLoading(false)
                console.log("PreviewCustLocDoc->Error->", error);
    });            
}
export async function DownloadCustLocDoc(e, doc_seq, setReportLoading, token, docType, docName){    
    e.preventDefault();
    console.log("PreviewCustLocDoc->doc_seq", doc_seq);
    console.log("PreviewCustLocDoc->token", token );
    console.log("PreviewCustLocDoc->docType", docType );
    //"work_order/documents/{doc_name}";
    const endPoint = process.env.REACT_APP_SERVER_BASE_URL +'/work_order/documents/'+doc_seq
    console.log("PreviewCustLocDoc->endPoint", endPoint );
    setReportLoading(true)
    await axios.get(endPoint,    
        {                
            headers: {                
                'Authorization':token,                    
            },
        }
        ).then(function (res){
            setReportLoading(false)       

                var contentType = ""
                if(docType === "pdf" || docType === "doc" || docType === "docx" || docType === "xls" || docType === "xlsx")
                    contentType = "application/"+docType;

                else if(docType === "jpg" || docType === "jpeg" || docType === "png" || docType === "bmp" || docType === "ico")
                    contentType = "image/"+docType;
                
                else if(docType === "text" || docType === "csv")
                    contentType = "text/"+docType;

                var file = new Blob([base64ToArrayBuffer(res.data)], { type: contentType });
                saveFile(file, docName);                                                       
            }).catch(function(error){
                setReportLoading(false)
                console.log("PreviewCustLocDoc->Error->", error);
    });            
}

//Report
export async function PreviewReport(e, WoId, setReportLoading, token){    
    e.preventDefault();
    console.log("WorkOrder->WoId", WoId);
    console.log("WorkOrder->token", token );
    setReportLoading(true)
    await axios.get(process.env.REACT_APP_SERVER_BASE_URL +'/work_order/report/preview?id='+WoId,    
        {                
            headers: {                
                'Authorization':token,                    
            },
        }
        ).then(function (res){
            setReportLoading(false)
                console.log("PreviewReport->data", res.data);                      
                var file = new Blob([base64ToArrayBuffer(res.data)], { type: 'application/pdf' });                    
                var fileURL = URL.createObjectURL(file);                    
                window.open(fileURL);                                       
               
            }).catch(function(error){
                setReportLoading(false)
                console.log("PreviewReport->Error->", error);
            });            
}
export  async function  DownloadReport(e, WoId, setPreViewLoading, token){    
    e.preventDefault();
    WriteLog("WorkOrder->WoId", WoId);
    WriteLog("WorkOrder->token", token );
    setPreViewLoading(true)
    await axios.get(process.env.REACT_APP_SERVER_BASE_URL +'/work_order/report/preview?id='+WoId,    
        {                
            headers: {                
                'Authorization':token,                    
            },
        }
        ).then(function (res){
            setPreViewLoading(false)
                // console.log("PreviewReport->data", res.data);                      
                 var file = new Blob([base64ToArrayBuffer(res.data)], { type: 'application/pdf' });                    
                // var fileURL = URL.createObjectURL(file);                    
                // window.open(fileURL);                                       
               saveFile(file, "WO"+WoId+".pdf");                                        
            }).catch(function(error){
                setPreViewLoading(false)
                WriteLog("PreviewReport->Error->", error);
        });
}

export function base64ToArrayBuffer (base64) {
    const binaryString = window.atob(base64); // Comment this if not using base64
    const bytes = new Uint8Array(binaryString.length);
    return bytes.map((byte, i) => binaryString.charCodeAt(i));
    }

export async function saveFile (blob, docName){
        const a = document.createElement('a');
        a.download = docName;
        a.href = URL.createObjectURL(blob);  
        a.addEventListener('click', (e) => {
            setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
          }); 
        a.click()
        console.log("File Saved");     
};    